import React from 'react';

import { DefinitionHeader } from 'components/common/fields/DefinitionHeader';
import { DefinitionField } from 'components/common/fields/DefinitionField';

import Translate from 'react-translate-component';

export const RequestStatus = ({ comments, status }) => (
    <div>
        <DefinitionHeader iconType="comment">
            <Translate content='status' component='span'/>:
            <span> {status}</span>
        </DefinitionHeader>
        {comments && <div className="panel-view">
            {comments.map((comment, index) => (
                <div key={index}>
                    <DefinitionField translate="request.organization">
                        <span>{comment.personName}</span>
                    </DefinitionField>
                    <DefinitionField translate="documents.date">
                        <span>{comment.date}</span>
                    </DefinitionField>
                    <DefinitionField translate="common.comment">
                        <span>{comment.comment}</span>
                    </DefinitionField>
                </div>
            ))}
        </div>}
    </div>
);
